import api from "../../api";
import { getContrastBW, prependHash } from "../../utils/color";

const state = () => ({
  loading: true,
  config: {
    logo: "/img/default_logo.png",
    favicon: "/img/default_logo.png",
    url: null,
    titleColor: "#000",
    descriptionColor: "#555",
    upperBackgroundColor: "#2e4d7f",
    lowerBackgroundColor: "#fff",
    innerBackgroundColor: "#f2f2f2",
    answerColor: "#000",
    choicesColor: "#406f82"
  }
});

const getters = {
  themeContrastColor: state => getContrastBW(state.config.upperBackgroundColor)
};

const mutations = {
  updateConfig(state, config) {
    Object.assign(state.config, config);
  },
  updateLoading(state, loading) {
    state.loading = loading;
  }
};

const actions = {
  async loadConfig({ commit }) {
    const config = await api.getConfig();
    const parsedConfig = {
      logo: config.urlLogo,
      url: config.url,
      favicon: config.urlLogo,
      titleColor: prependHash(config.cor_titulo),
      descriptionColor: prependHash(config.cor_descricao),
      upperBackgroundColor: prependHash(config.cor_back_cima),
      lowerBackgroundColor: prependHash(config.cor_back_baixo),
      innerBackgroundColor: prependHash(config.cor_interna),
      answerColor: prependHash(config.cor_enunciado_resp),
      choicesColor: prependHash(config.cor_radio_check)
    };

    commit("updateConfig", parsedConfig);
    commit("updateLoading", false);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
